import { render, staticRenderFns } from "./SubmenuTree.vue?vue&type=template&id=35afe409&scoped=true"
import script from "./SubmenuTree.vue?vue&type=script&lang=js"
export * from "./SubmenuTree.vue?vue&type=script&lang=js"
import style0 from "./SubmenuTree.vue?vue&type=style&index=0&id=35afe409&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35afe409",
  null
  
)

export default component.exports